export const PENDING_PROMOTION_STORAGE_KEY = "realtylink_pending_promo"

export function normalizePromotionCode(value: string | null | undefined): string {
  const trimmed = String(value || "").trim()
  return trimmed.length > 0 ? trimmed : ""
}

/** Read promo coupon from URL — supports `?promo=` and common typo `?promot=` */
export function getPromoCodeFromSearchParams(
  searchParams: { get: (key: string) => string | null }
): string {
  return normalizePromotionCode(searchParams.get("promo") || searchParams.get("promot"))
}

export function savePendingPromotion(couponCode: string) {
  const code = normalizePromotionCode(couponCode)
  if (!code || typeof window === "undefined") return
  localStorage.setItem(PENDING_PROMOTION_STORAGE_KEY, code)
}

export function getPendingPromotion(): string {
  if (typeof window === "undefined") return ""
  return normalizePromotionCode(localStorage.getItem(PENDING_PROMOTION_STORAGE_KEY))
}

export function clearPendingPromotion() {
  if (typeof window === "undefined") return
  localStorage.removeItem(PENDING_PROMOTION_STORAGE_KEY)
}

/** Remove promo query params (does not mutate the input). */
export function withoutPromoSearchParams(
  searchParams: { toString: () => string }
): URLSearchParams {
  const params = new URLSearchParams(searchParams.toString())
  params.delete("promo")
  params.delete("promot")
  return params
}

/** Append `?promo=` to a path when a coupon code is available. */
export function appendPromoToPath(path: string, promoCode: string): string {
  const code = normalizePromotionCode(promoCode)
  if (!code) return path

  const [pathname, existingQuery = ""] = path.split("?")
  const params = new URLSearchParams(existingQuery)
  params.set("promo", code)
  return `${pathname}?${params.toString()}`
}

/** Resolve promo from URL search params, optionally falling back to pending storage. */
export function resolvePromotionCode(
  searchParams: { get: (key: string) => string | null },
  options?: { fallbackToPending?: boolean }
): string {
  const fromUrl = getPromoCodeFromSearchParams(searchParams)
  if (fromUrl) return fromUrl
  if (options?.fallbackToPending) return getPendingPromotion()
  return ""
}
